import React from "react";
import { Redirect } from "react-router-dom";
import { Box, Grid, Heading, Text, VStack } from "@chakra-ui/react";
import { ReactComponent as Logo } from "assets/logo.svg";
import { useUser } from "context/user";

const Portal: React.FC = () => {
  const { user } = useUser()!;
  if (user.id && !user.has_accepted_eula) return <Redirect push to="/eula" />;

  return (
    <Grid minH="100vh" justifyContent="center" alignItems="center" p={[8, 12]}>
      <VStack spacing={8}>
        <Box w={["full", 400]}>
          <Logo />
        </Box>
        <Heading as="h1" pt={[0, 8]} size="xl" textAlign="center">
          Welcome to{" "}
          <Text as="span" color="blue.500">
            Charisma
          </Text>
          , {user.first_name ?? user.username}
        </Heading>
      </VStack>
    </Grid>
  );
};

export default Portal;
